import Vue from 'vue';
import Router from 'vue-router';
import home from '@/views/home.vue';
import aboutUs from '@/views/aboutUs.vue';
import successCases from '@/views/successCases.vue';
import companyNews from '@/views/companyNews.vue';
import businessCooperation from '@/views/businessCooperation.vue';
import appWebsite from '@/views/appWebsite.vue';
Vue.use(Router);
const routes = [
  { path: '/', component: home },
  { path: '/aboutUs', component: aboutUs },
  { path: '/successCases', component: successCases },
  { path: '/companyNews', component: companyNews },
  { path: '/businessCooperation', component: businessCooperation },
  { path: '/appWebsite', component: appWebsite },
]

export default new Router({ routes })
